import {css, StyleSheet} from "aphrodite";
import React from 'react';
import GridStyles from "../../styles/styles";
import WhatsNewArea from "../WhatsNewArea/WhatsNewArea";
import FeaturesArea from "../FeaturesArea";
import Config from "../../config/Config";
import CardsArea from "../CardsArea";
import MediaQuery from "../../styles/MediaQuery";
import TextDiv from "../containers/TextDiv";
import Switching from "../Switching";

const SwitchC = ({extraStyle}) => {
    const styles = StyleSheet.create({
            container: {
                ...GridStyles.define("max-content 70px max-content 60px max-content 101px max-content 60px max-content 120px max-content", "auto"),
                ...MediaQuery.mobile({
                    ...GridStyles.define("max-content 49px max-content 30px max-content 80px max-content 30px max-content 60px max-content", "auto")
                })
            },
            whatsNew: GridStyles.setRowCol(1, 1),
            featuresAreaFirst: GridStyles.setRowCol(3, 1),
            cardsAreaFirst: GridStyles.setRowCol(5, 1),
            separatorFirst: {
                ...GridStyles.setRowCol(6, 1),
                backgroundColor: Config.colors.CARDS_BACKGROUND
            },
            featuresAreaSecond: {
                ...GridStyles.setRowCol(7, 1),
                backgroundColor: Config.colors.CARDS_BACKGROUND
            },
            separatorSecond: {
                ...GridStyles.setRowCol(8, 1),
                backgroundColor: Config.colors.CARDS_BACKGROUND
            },
            cardsAreaSecond: GridStyles.setRowCol(9, 1),
            switching: GridStyles.setRowCol(11, 1),
        }),
        features = [
            {
                title: Config.messages.fasterTitle,
                description: Config.messages.fasterDescription,
                image: Config.images.FEATURE_FASTER
            },
            {
                title: Config.messages.advancedTitle,
                description: Config.messages.advancedDescription,
                image: Config.images.FEATURE_ADVANCED
            },
            {
                title: Config.messages.privacyTitle,
                description: Config.messages.privacyDescription,
                image: Config.images.FEATURE_PRIVACY
            }
        ],
        cards = [
            {
                title: Config.messages.blockCard,
                image: Config.images.BLOCK_CARD
            },
            {
                title: Config.messages.shopCard,
                image: Config.images.SHOP_CARD
            },
            {
                title: Config.messages.encryptCard,
                image: Config.images.ENCRYPT_CARD
            },
            {
                title: Config.messages.vpnCard,
                image: Config.images.VPN_CARD
            },
            {
                title: Config.messages.trackCard,
                image: Config.images.TRACK_CARD
            },
            {
                title: Config.messages.leakCard,
                image: Config.images.LEAK_CARD
            },
        ];

    return (
        <div className={css(styles.container, extraStyle)}>
            <WhatsNewArea extraStyle={styles.whatsNew}/>
            <FeaturesArea key={1} features={features.slice(0, 2)} extraStyle={styles.featuresAreaFirst}/>
            <CardsArea extraStyle={styles.cardsAreaFirst} cards={cards.slice(0, 3)} key={2}/>
            <TextDiv extraStyle={styles.separatorFirst}/>
            <FeaturesArea key={3} features={[...features.slice(2)]} extraStyle={styles.featuresAreaSecond}/>
            <TextDiv extraStyle={styles.separatorSecond}/>
            <CardsArea reverse={true} extraStyle={styles.cardsAreaSecond} cards={cards.slice(3)} key={4}/>
            <Switching extraStyle={styles.switching}/>
        </div>
    );
};

export default SwitchC;
